import { render, staticRenderFns } from "./UserAria.vue?vue&type=template&id=f1bf4308&"
import script from "./UserAria.vue?vue&type=script&lang=js&"
export * from "./UserAria.vue?vue&type=script&lang=js&"
import style0 from "./UserAria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports